import { z } from "zod";

export const emailSchema = z
  .string()
  .trim()
  .min(1, "Email is required.")
  .email("Please enter a valid email address.")
  .max(254, "Email address is too long.")
  .refine((email) => !email.includes(".."), "Email cannot contain consecutive dots.")
  .refine((email) => {
    const [local] = email.split("@");
    return local && !local.startsWith(".") && !local.endsWith(".");
  }, "Please enter a valid email address.")
  .refine((email) => {
    const [, domain] = email.split("@");
    return /\.(com|co\.in|in|ae|org|net)$/i.test(domain);
  }, "Please enter a valid email domain.")
  .refine((email) => {
    const [, domain] = email.split("@");
    return domain && domain.length <= 50;
  }, "Domain name is too long.");
